/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface PersonEmailDTO
 */
export interface PersonEmailDTO  {
    /**
     * 
     * @type {number}
     * @memberof PersonEmailDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonEmailDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonEmailDTO
     */
    type?: string;
}

/**
 * Check if a given object implements the PersonEmailDTO interface.
 */
export function instanceOfPersonEmailDTO(value: object): value is PersonEmailDTO {
    return true;
}

export function PersonEmailDTOFromJSON(json: any): PersonEmailDTO {
    return PersonEmailDTOFromJSONTyped(json, false);
}

export function PersonEmailDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonEmailDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'email': json['email'] == null ? undefined : json['email'],
                  'type': json['type'] == null ? undefined : json['type'],
    };
}

export function PersonEmailDTOToJSON(json: any): PersonEmailDTO {
    return PersonEmailDTOToJSONTyped(json, false);
}

export function PersonEmailDTOToJSONTyped(value?: PersonEmailDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'email': value['email'],
        'type': value['type'],
    };
}


